export default "__VITE_ASSET__DeH5PpL8__"